// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3ZNvw","background":"background__1IEDC","messageContainer":"messageContainer__3j-xX","title":"title__1KSK3","message":"message__3qi59"};